var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('KazangBanner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"text-center text-dark"},[_c('b',[_vm._v("Lyt-Soft Utilities")])])
}]

export { render, staticRenderFns }